module.exports = __webpack_public_path__ + "static/media/14UNEP10.e7df91fd.jpg";